import { useQuery } from 'react-query'
import { configAPI } from '../utils/api'

// Hook para obtener configuración del sistema
export const useSystemConfig = () => {
  return useQuery(
    ['system-config'],
    () => configAPI.getSystemConfig(),
    {
      staleTime: 15 * 60 * 1000, // 15 minutos
      cacheTime: 30 * 60 * 1000, // 30 minutos
      select: (data) => data.data,
      retry: 1
    }
  )
}

export default useSystemConfig
